import script from "./Acts.vue?vue&type=script&setup=true&lang=js"
export * from "./Acts.vue?vue&type=script&setup=true&lang=js"

import "./Acts.vue?vue&type=style&index=0&id=9547a1c2&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9547a1c2"]])

export default __exports__